module.exports = __webpack_public_path__ + "static/img/file-word.afa2b938.svg";